import React, {Fragment} from "react";
import {Link} from "react-router-dom";
import LazyVideo from "../../../Components/LazyVideo/LazyVideo";

const Video = ({themeDelegate, available, isSubscribed}) => {
    return (
        <div className={"video-container"}>
            <div className={"box"}>
                {themeDelegate.state.data.lecture.map((item, index) => (
                    <Fragment key={index}>
                        <h3>Видеолекция: {item.name}</h3>
                        <div className={"video"}>
                            {available ? (
                                <LazyVideo
                                    title={item.name}
                                    link={`https://vimeo.com/${item.id_video}`}
                                />
                            ) : (
                                <div className={"video-non"}>
                                    <img src={"/Images/video.svg"} alt={"😼"}/>
                                    <p>Включите опцию, чтобы смотреть видеоурок </p>
                                    {/*<Link to={isSubscribed ? '/subscription' : `/billing/${themeDelegate.state.data.stage.level.course.id}`}> <button>Включить</button></Link>*/}
                                    <Link to={`/billing`}> <button>Включить</button></Link>

                                </div>
                            )}



                        </div>
                    </Fragment>
                ))}

            </div>
        </div>
    )
}
export default Video;
